import { Controller } from "react-hook-form";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { MuiTelInput } from "mui-tel-input";
import { useTranslation } from "react-i18next";
import {
	phoneInputDefaultCountryDictionary,
	phoneInputLangOfCountriesDictionary,
	phoneInputPreferredCountries,
} from "../../../constants";

const ControlledPhoneInputSeparatedLabel = ({
	control,
	defaultValue = "",
	name,
	label,
	error,
	errorMessage,
	startAdornment,
	endAdornment,
	labelXs = 5,
	fieldXs = 7,
	...rest
}) => {
	const { i18n } = useTranslation();

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => (
				<Grid container columnSpacing={2} rowSpacing={0}>
					<Grid
						sx={{
							display: "flex",
							alignItems: rest.multiline ? "start" : "center",
						}}
						size={labelXs}
					>
						<Typography
							variant="label"
							component="label"
							htmlFor="bootstrap-input"
							sx={{ mt: rest.multiline ? 0.4 : 0 }}
						>
							{label}:
						</Typography>
					</Grid>
					<Grid sx={{ display: "flex", alignItems: "center" }} size={fieldXs}>
						<MuiTelInput
							className="phone-input"
							forceCallingCode
							defaultCountry={
								phoneInputDefaultCountryDictionary[i18n.language] || "PL"
							}
							langOfCountryName={
								phoneInputLangOfCountriesDictionary[i18n.language] || "PL"
							}
							preferredCountries={phoneInputPreferredCountries}
							continents={["EU"]}
							size="small"
							fullWidth
							value={value}
							onChange={onChange}
							error={error}
							helperText={errorMessage ? errorMessage : ""}
							{...rest}
						/>
					</Grid>
				</Grid>
			)}
		></Controller>
	);
};

export default ControlledPhoneInputSeparatedLabel;
